// eslint-disable-next-line import/no-unresolved
import keenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

class FeaturedProducts extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector('[data-el="featured-products.slides"]')
    this.slideEls = this.querySelectorAll('[data-el="featured-products.slide"]')
    this.controlPrevEl = this.querySelector(
      '[data-el="featured-products.controlprevious"]'
    )
    this.controlNextEl = this.querySelector(
      '[data-el="featured-products.controlnext"]'
    )
    this.scrollerEl = this.querySelector(
      '[data-el="featured-products.scroller"]'
    )

    this.carousel = this.initialiseCarousel()

    this.controlPrevEl.addEventListener('click', this.onNavClick.bind(this))

    this.controlNextEl.addEventListener('click', this.onNavClick.bind(this))
  }

  initialiseCarousel () {
    this.classList.add(`sec-FeaturedProducts-${this.slideEls.length}`)
    // eslint-disable-next-line new-cap
    return new keenSlider(this.slidesEl, {
      slides: '.car-Carousel_Slide',
      slidesPerView: 1.33333,
      spacing: 5,
      rubberband: false,
      breakpoints: {
        '(min-width: 600px)': {
          slidesPerView: 2,
          spacing: 5,
        },
        '(min-width: 768px)': {
          slidesPerView: 2.4,
          spacing: 10,
        },
        '(min-width: 901px)': {
          slidesPerView: 3,
          spacing: 10,
        },
        '(min-width: 1201px)': {
          slidesPerView: 4,
          spacing: 10,
        },
      },
      created: () => {
        this.slidesEl.classList.remove('car-Carousel_Slides-hidden')
      },
      slideChanged: instance => {
        const maxClicks =
          instance.details().size - instance.details().slidesPerView

        instance.details().relativeSlide === 0
          ? (this.controlPrevEl.disabled = true)
          : (this.controlPrevEl.disabled = false)
        instance.details().relativeSlide >= maxClicks
          ? (this.controlNextEl.disabled = true)
          : (this.controlNextEl.disabled = false)
      },
      move: instance => {
        if (this.scrollerEl) {
          let progressTrack = instance.details().progressTrack
          progressTrack = progressTrack >= 1 ? 0 : progressTrack
          const movementPercentage = progressTrack * 100
          this.scrollerEl.style.setProperty(
            '--movement',
            `${movementPercentage}%`
          )
        }
      },
    })
  }

  onNavClick (event) {
    if (event.currentTarget.dataset.direction === 'previous') {
      this.carousel.prev()
    } else {
      this.carousel.next()
    }
  }
}

customElements.define('featured-products', FeaturedProducts)
